import { render } from "./PasswordConfirmNew.vue?vue&type=template&id=ef897310"
import script from "./PasswordConfirmNew.vue?vue&type=script&lang=js"
export * from "./PasswordConfirmNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__